import { apiAuthCall } from '@/utils/api'

export const classroomDiary = (classId) => {
  const url = process.env.API_TEST ? '/getDiary'
    : `/api/agendadiaria/classroom/${classId}/students`
  return apiAuthCall({ url, data: {}, method: 'GET' })
}



// WEBPACK FOOTER //
// ./src/utils/endpoints.js